import Core from '@aws-amplify/core';
import { API } from '@aws-amplify/api';

Core.Logger.LOG_LEVEL =
  process.env.REACT_APP_ENV === 'production' ? 'ERROR' : 'DEBUG';

const env = process.env.REACT_APP_ENV;

API.configure({
  endpoints: [
    {
      name: process.env.REACT_APP_AWS_API_GATEWAY_NAME,
      endpoint:
        env === 'local'
          ? process.env.REACT_APP_API_GATEWAY_ENDPOINT
          : window.__RUNTIME_ENV__?.REACT_APP_API_GATEWAY_ENDPOINT
    }
  ]
});
